import type { PakistanRegionId } from './pakistanMap'

/* This is the showroom's public coverage story, rather than an export of
   customer records. Keep geography beside each name so a change to the
   displayed cities cannot silently leave the pins in the old places. */
export type ReachCity = {
  name: string
  longitude: number
  latitude: number
}

export type ReachRegion = {
  id: PakistanRegionId
  name: string
  shortName: string
  description: string
  cities: ReachCity[]
}

export const SHOWROOM_CITY: ReachCity = {
  name: 'Islamabad', longitude: 73.0479, latitude: 33.6844,
}

export const CLIENT_REGIONS: ReachRegion[] = [
  {
    id: 'punjab', name: 'Punjab', shortName: 'Punjab',
    description: 'From the twin cities to the heart of Punjab.',
    cities: [
      { name: 'Lahore', longitude: 74.3587, latitude: 31.5204 },
      { name: 'Rawalpindi', longitude: 73.0479, latitude: 33.5651 },
      { name: 'Faisalabad', longitude: 73.135, latitude: 31.4504 },
      { name: 'Multan', longitude: 71.5249, latitude: 30.1575 },
    ],
  },
  {
    id: 'sindh', name: 'Sindh', shortName: 'Sindh',
    description: 'A shared love of the drive, from the Indus to the coast.',
    cities: [
      { name: 'Karachi', longitude: 67.0011, latitude: 24.8607 },
      { name: 'Hyderabad', longitude: 68.3578, latitude: 25.396 },
      { name: 'Sukkur', longitude: 68.8574, latitude: 27.7139 },
      { name: 'Larkana', longitude: 68.2141, latitude: 27.557 },
    ],
  },
  {
    id: 'khyber-pakhtunkhwa', name: 'Khyber Pakhtunkhwa', shortName: 'Khyber Pakhtunkhwa',
    description: 'Connections that reach beyond the mountain roads.',
    cities: [
      { name: 'Peshawar', longitude: 71.5249, latitude: 34.0151 },
      { name: 'Mardan', longitude: 72.0525, latitude: 34.1989 },
      { name: 'Abbottabad', longitude: 73.2215, latitude: 34.1688 },
      { name: 'Mingora', longitude: 72.36, latitude: 34.7717 },
    ],
  },
  {
    id: 'balochistan', name: 'Balochistan', shortName: 'Balochistan',
    description: 'Across open highways and all the way to the Makran coast.',
    cities: [
      { name: 'Quetta', longitude: 66.9905, latitude: 30.1798 },
      { name: 'Gwadar', longitude: 62.3254, latitude: 25.1264 },
      { name: 'Turbat', longitude: 63.0549, latitude: 26.0023 },
      { name: 'Khuzdar', longitude: 66.611, latitude: 27.8119 },
    ],
  },
  {
    id: 'ajk', name: 'Azad Jammu & Kashmir', shortName: 'AJK',
    description: 'Our client family, across the valleys of Azad Kashmir.',
    cities: [
      { name: 'Muzaffarabad', longitude: 73.4711, latitude: 34.37 },
      { name: 'Mirpur', longitude: 73.7517, latitude: 33.148 },
      { name: 'Kotli', longitude: 73.8973, latitude: 33.5156 },
      { name: 'Rawalakot', longitude: 73.7604, latitude: 33.8578 },
    ],
  },
  {
    id: 'gilgit-baltistan', name: 'Gilgit-Baltistan', shortName: 'Gilgit-Baltistan',
    description: 'The same trust, on the roads of the great north.',
    cities: [
      { name: 'Gilgit', longitude: 74.3087, latitude: 35.9208 },
      { name: 'Skardu', longitude: 75.6333, latitude: 35.2971 },
      { name: 'Karimabad', longitude: 74.6645, latitude: 36.3265 },
      { name: 'Chilas', longitude: 74.1021, latitude: 35.4269 },
    ],
  },
]
